import NavItemIcon from "./NavItemIcon";

export default NavItemIcon;
